import { Link } from "react-router-dom";

const categoryLinks = [
  { label: "直播圈", to: "/topics?category=live" },
  { label: "短视频", to: "/topics?category=short" },
  { label: "电商带货", to: "/topics?category=commerce" },
  { label: "综艺娱乐", to: "/topics?category=variety" },
  { label: "社交平台", to: "/topics?category=social" },
  { label: "音乐现场", to: "/topics?category=music" },
];

const siteLinks = [
  { label: "首页", to: "/" },
  { label: "事件档案库", to: "/topics" },
  { label: "吃瓜百科", to: "/#glossary" },
  { label: "用户口碑", to: "/#voice" },
  { label: "常见问题", to: "/#faq" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-secondary-950">
                <i className="ri-leaf-line" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl tracking-wide text-background-50">瓜田观察站</span>
            </div>
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-background-200">
              把分散的网络热点收进档案，按分类归档、用时间线讲清脉络。理性围观，不越边界。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900 text-background-200 transition-colors duration-200 hover:bg-accent-500 hover:text-secondary-950"
                >
                  <i className={`${icon} text-base`} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-medium tracking-wide text-accent-300">
              <Link to="/topics" className="transition-colors hover:text-accent-200">
                内容分类
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categoryLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="font-body text-sm text-background-200 transition-colors duration-200 hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-medium tracking-wide text-accent-300">站内导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {siteLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="font-body text-sm text-background-200 transition-colors duration-200 hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-medium tracking-wide text-accent-300">联系与投稿</h4>
            <p className="mt-4 font-body text-sm leading-relaxed text-background-200">
              有线索、纠错或合作意向，欢迎通过联系表单留言，我们会逐一核对。
            </p>
            <ul className="mt-4 flex flex-col gap-2.5 font-body text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300" aria-hidden="true"></i>
                contact@guatian-observer.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-300" aria-hidden="true"></i>
                档案更新：工作日 10:00 - 19:00
              </li>
            </ul>
            <Link
              to="/about#contact"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 font-label text-sm font-medium text-secondary-950 transition-colors duration-200 hover:bg-accent-400"
            >
              前往联系表单
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs leading-relaxed text-background-300">
            © {year} 瓜田观察站 · 内容均为公开信息整理，仅供围观参考，不构成任何事实认定或投资建议。
          </p>
          <p className="font-body text-xs text-background-300">
            本站不呈现任何个人隐私信息 · 拒绝人肉与猜测式传播
          </p>
        </div>
      </div>
    </footer>
  );
}